import { Checkbox } from "@vds/checkboxes";
import styled from "styled-components";

export const StyledCheckbox = styled(Checkbox)`
  > div {
    background-color: #ffffff;
  }
`;
